import { render, staticRenderFns } from "./payrollReportv2.vue?vue&type=template&id=3bd9b025&"
import script from "./payrollReportv2.vue?vue&type=script&lang=js&"
export * from "./payrollReportv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports